module.exports = "/img/_/_/_/assets/images/creeper/book/legendary//1.jpg?9333a8cac7718e8b0f9ecde663dfa9b6";